// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/restaurant/celebration_details.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/restaurant/celebration_details.proto.
 */
export const file_proto_model_booking_restaurant_celebration_details = /*@__PURE__*/
  fileDesc("Cjhwcm90by9tb2RlbC9ib29raW5nL3Jlc3RhdXJhbnQvY2VsZWJyYXRpb25fZGV0YWlscy5wcm90bxIGY2FybWVuItMBChJDZWxlYnJhdGlvbkRldGFpbHMSMQoQY2VsZWJyYXRpb25fdHlwZRgBIAEoDjIXLmNhcm1lbi5DZWxlYnJhdGlvblR5cGUSHwoXY2VsZWJyYXRpb25fZGVzY3JpcHRpb24YAiABKAkSHAoUc3VycHJpc2VfY2VsZWJyYXRpb24YAyABKAgSGAoQc3BlY2lhbF9yZXF1ZXN0cxgEIAMoCRIZChFkZXNzZXJ0X3JlcXVlc3RlZBgFIAEoCBIWCg5jdXN0b21fbWVzc2FnZRgGIAEoCSq6AgoPQ2VsZWJyYXRpb25UeXBlEiAKHENFTEVCUkFUSU9OX1RZUEVfVU5TUEVDSUZJRUQQABIdChlDRUxFQlJBVElPTl9UWVBFX0JJUlRIREFZEAESIAocQ0VMRUJSQVRJT05fVFlQRV9BTk5JVkVSU0FSWRACEh8KG0NFTEVCUkFUSU9OX1RZUEVfRU5HQUdFTUVOVBADEh8KG0NFTEVCUkFUSU9OX1RZUEVfR1JBRFVBVElPThAEEh4KGkNFTEVCUkFUSU9OX1RZUEVfUFJPTU9USU9OEAUSHwobQ0VMRUJSQVRJT05fVFlQRV9EQVRFX05JR0hUEAYSJQohQ0VMRUJSQVRJT05fVFlQRV9CVVNJTkVTU19NRUVUSU5HEAcSGgoWQ0VMRUJSQVRJT05fVFlQRV9PVEhFUhAIQjBaLmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2Jvb2tpbmdiBnByb3RvMw");

/**
 * Describes the message carmen.CelebrationDetails.
 * Use `create(CelebrationDetailsSchema)` to create a new message.
 */
export const CelebrationDetailsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_restaurant_celebration_details, 0);

/**
 * Describes the enum carmen.CelebrationType.
 */
export const CelebrationTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_restaurant_celebration_details, 0);

/**
 * @generated from enum carmen.CelebrationType
 */
export const CelebrationType = /*@__PURE__*/
  tsEnum(CelebrationTypeSchema);

